import { getNavigationLinks } from '../config/navigationLinks';
import { buildUtmLink } from './utm';

export const SIGNUP_ROUTE = '/signup';
export const LOGIN_ROUTE = '/login';

const buildTrackedLink = (location, { href, utmCampaign, anchor, ...rest }) => ({
  ...rest,
  href,
  anchor,
  utmCampaign,
  to: buildUtmLink({
    pathname: href,
    location,
    utmCampaign: utmCampaign || 'nav',
    hash: anchor,
  }),
});

export const getPrimaryNavigationLinks = ({
  location,
  includeHomeAnchors = false,
  user,
} = {}) => {
  const links = getNavigationLinks({ includeHomeAnchors });
  return links
    .filter((link) => !link.requiresAuth || Boolean(user))
    .map((link) => buildTrackedLink(location, link));
};

export const ensureHomeFirst = (links) => {
  const items = [...links];
  const homeIndex = items.findIndex((link) => link.href === '/');
  if (homeIndex > 0) {
    const [home] = items.splice(homeIndex, 1);
    items.unshift(home);
  }
  return items;
};

export const getAuthLinks = (
  location,
  { signupCampaign = 'nav_signup', loginCampaign = 'nav_login' } = {},
) => ({
  signup: buildUtmLink({ pathname: SIGNUP_ROUTE, location, utmCampaign: signupCampaign }),
  login: buildUtmLink({ pathname: LOGIN_ROUTE, location, utmCampaign: loginCampaign }),
});

export default getPrimaryNavigationLinks;
